import React, { useCallback } from 'react';
import { ReactComponent as PeopleIcon } from '@lifesize/ux-assets/vectors/svgIcons/people.svg';
import { ReactComponent as PersonIcon } from '@lifesize/ux-assets/vectors/svgIcons/person.svg';
import { ReactComponent as ManualDialIcon } from '@lifesize/ux-assets/vectors/svgIcons/hashtag.svg';
import { ReactComponent as OtmIcon } from '@lifesize/ux-assets/vectors/svgIcons/hourglass.svg';
import { ReactComponent as RoomSystemIcon } from '@lifesize/ux-assets/vectors/svgIcons/room-system.svg';

// Enum needs strings assigned to map to older js/ES6 code that uses strings as identifiers
export enum IconType {
  manual = 'manual',
  meeting = 'meeting',
  oneTime = 'oneTime',
  people = 'people',
  person = 'person',
  roomSystem = 'roomSystem',
  user = 'user'
}

interface PulsingAvatarProps {
  iconType: IconType;
}

/**
 * useCallback to return svg icons of different types by enum
 */
const AvatarIcon = (props: PulsingAvatarProps) => {
  const { iconType } = props;

  const getIcon = useCallback((type: IconType) => {
    switch (type) {
      case IconType.manual:
        return <ManualDialIcon data-testid="manual-dial-avatar-icon" />;
      case IconType.meeting:
      case IconType.people:
        return <PeopleIcon data-testid="people-avatar-icon" />;
      case IconType.oneTime:
        return <OtmIcon data-testid="otm-avatar-icon" />;
      case IconType.person:
      case IconType.user:
        return <PersonIcon data-testid="person-avatar-icon" />;
      case IconType.roomSystem:
        return <RoomSystemIcon data-testid="room-system-avatar-icon" />;
    }
  }, []);

  return <>{getIcon(iconType)}</>;
};

export default AvatarIcon;
